module.exports = __webpack_public_path__ + "img/empty.708f773d.png";